<template>
  <a-config-provider :locale="zhCN">
    <router-view/>
  </a-config-provider>
</template>

<script>
import {setDeviceType} from "@/utils/device";
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default {
  name: 'App',

  setup() {
    setDeviceType();
    return {
      zhCN,
    }
  }
}
</script>
